export default __webpack_public_path__ + "static/media/output-onlinepngtools.60e77c62.png";